import low from 'lowdb';
import LocalStorage from 'lowdb/adapters/LocalStorage';
var adapter = new LocalStorage('admin');
var db = low(adapter);
db.defaults({
  sys: {},
  database: {},
  tableColumn: {}
}).write();
export default db;